module.exports = __webpack_public_path__ + "static/img/invest-make4.4f440ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/investCase/invest-make4.jpg
// module id = GhWZ
// module chunks = 0